<template>
  <div id="game_02">
    <div class="game_wrapper">
      <div class="game">
        <div class="target" :style="{ backgroundImage: `url(${publicPath}img/game/02/target.png)`}"></div>
        <div class="target active" :style="{ backgroundImage: `url(${publicPath}img/game/02/target_active.png)`}"></div>
        <div class="guage" :style="{ backgroundImage: `url(${publicPath}img/game/02/guage.png)`}"></div>
        <div class="guide" :style="{ backgroundImage: `url(${publicPath}img/game/02/guide.png)`}"></div>
      </div>

      <div class="correct_anim">
        <div class="target" :style="{ backgroundImage: `url(${publicPath}img/game/02/target_active.png)`}"></div>
        <div class="anim" :style="{ backgroundImage: `url(${publicPath}img/game/02/correct_anim.png)`}"></div>
        <div class="correct" :style="{ backgroundImage: `url(${publicPath}img/game/02/correct.png)`}"></div>
      </div>
    </div>
    <div class="txt_wrapper">
      <div class="chara" :style="{ backgroundImage: `url(${publicPath}img/game/02/icon_tsubame.png)`}"></div>
      <div class="txt" :style="{ backgroundImage: `url(${publicPath}img/game/02/bg_txt.png)`}">
        <div class="txt_01" :style="{ backgroundImage: `url(${publicPath}img/game/02/txt.png)`}"></div>
        <div class="correct" :style="{ backgroundImage: `url(${publicPath}img/game/02/txt_correct.png)`}"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    data() {
      return {
        // 変更不可 -------------------------
        publicPath: process.env.BASE_URL,
        // ---------------------------------
        timer: '',
        posX: [],
        state: {
          pos: 0,
          rFlg: false,
          stop: false,
        },
        tyming: 11,
        sendDelay: 1000,
        result: false
      }
    },
    mounted () {
      // let vh = window.innerHeight * 0.01;
      // document.documentElement.style.setProperty('--vh', `${vh}px`)

      for(let i = 0; i < this.tyming; i++) {
        let num = (608 / (this.tyming -1) * i - 200) / 7.50
        this.posX.push(Math.floor(num * 100) /100)
      }

      $('#game_02').on('touchstart', this.stop)
      this.start()
    },
    destroyed () {
      $('#game_02').off('touchstart', this.stop)
      clearInterval(this.timer)
    },
    methods: {
      start() {
        this.timer = setInterval(() => {
          this.state.pos = this.state.rFlg ? this.state.pos - 1 : this.state.pos + 1

          $('#game_02 .game .guide').css({left: this.posX[this.state.pos] + 'vw'})

          if(this.state.pos === 0 || this.state.pos === 10) this.state.rFlg = !this.state.rFlg
        } ,300)
      },
      stop() {
        if(this.state.stop) return
        this.state.stop = !this.state.stop

        clearInterval(this.timer)
        
        switch(this.state.pos) {
          case 5:
            this.result = !this.result
            $('#game_02 .game .target.active').show()
            setTimeout(this.anim, 500)
            break
          default: 
            setTimeout(this.sendResult, this.sendDelay)
        }
      },
      anim() {
        $('#game_02 .game').hide()
        $('#game_02 .txt_wrapper .txt_01').hide()
        $('#game_02 .correct_anim').show()

        setTimeout(() => {
          $('#game_02 .correct_anim .target').hide()
          $('#game_02 .correct_anim .anim').hide()
          $('#game_02 .txt_wrapper .correct').show()
          $('#game_02 .correct_anim .correct').show()

          setTimeout(this.sendResult, this.sendDelay)
        }, 3000)
      },
      // ゲーム結果を送信 --- クリアの時は「true」、失敗の時は「false」-------------
      sendResult: function(){
        this.$emit('gameResult', this.result);
      }
    }
  }
</script>

<style lang="scss" scoped>
  #game_02 {
    // height: 100vh;
    // height: calc(var(--vh, 1vh) * 100);
    width: 100%;
    height: 100%;
    position: relative;

    .game_wrapper {
      position: relative;
      width: 100%;
      // 100% - (.txtのheight + 上下margin)
      height: calc(100% - 30.66vw);
      overflow: hidden;

      .game {
        position: absolute;
        top: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 89.6vw;

        div {
          position: absolute;
        }

        .target {
          top: 22.66vw;
          right: 0;
          left: 0;
          margin: 0 auto;
          width: 24vw;
          height: 24vw;
          background: left top no-repeat;
          background-size: 100% auto;

          &.active {
            display: none;
          }
        }

        .guage {
          right: 0;
          bottom: 0;
          left: 0;
          margin: 0 auto;
          width: 89.86vw;
          height: 11.46vw;
          background: left top no-repeat;
          background-size: 100% auto;
        }

        .guide {
          top: 0;
          left: -26.93vw;
          width: 72vw;
          height: 89.6vw;
          background: left top no-repeat;
          background-size: 100% auto;
        }
      }

      .correct_anim {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        display: none;
        transform: translateY(-10.13vw);
        height: 115.2vw;

        div {
          position: absolute;
        }

        .target {
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
          width: 24vw;
          height: 24vw;
          background: left top no-repeat;
          background-size: 100%;
        }

        .anim {
          width: 100%;
          height: 100%;
          background: center center no-repeat;
          background-size: 100%;
          animation: 1s steps(3) 0s infinite correctAnim;
        }

        .correct {
          display: none;
          width: 100%;
          height: 100%;
          background: center center no-repeat;
          background-size: 100%;
        }
      }
    }

    .txt_wrapper {
      position: relative;
      margin: 4.53vw auto;
      height: 21.6vw;

      div {
        position: absolute;
        top: 0;
      }

      .chara {
        left: 8.26vw;
        width: 12.26vw;
        height: 20.53vw;
        background: center center no-repeat;
        background-size: 100%;
      }

      .txt {
        right: 5.06vw;
        width: 71.06vw;
        height: 20.26vw;
        background: left top no-repeat;
        background-size: 100%;

        div {
          position: absolute;
          top: 5.6vw;
          left: 11.6vw;
          background: left top no-repeat;
          background-size: 100%;
        }

        .txt_01 {
          width: 44.66vw;
          height: 9.06vw;
        }

        .correct {
          display: none;
          width: 25.46vw;
          height: 9.06vw;
        }
      }
    }

    @keyframes correctAnim {
      0% {
        background-size: 100%;
      }
      100% {
        background-size: 175%
      }
    }
  }
</style>
